import { StringContext } from "../../core/StringContext";
import { StringData } from "../../core/StringData";
import { StringModule } from "../../core/StringModule";
import { StringObject } from "../../objects/StringObject";

export abstract class CursorReactiveModule extends StringModule {
  protected nearOnly = true;
  protected emitEveryN = 2;
  protected updateThreshold = 0.1;
  private rafFrame = 0;

  constructor(context: StringContext) {
    super(context);
  }

  override onObjectConnected(object: StringObject): void {
    super.onObjectConnected(object);
    this.centers.attach(object);
    this.hover.track(object);
  }

  override removeObject(id: string): void {
    const obj = this.objectMapOnPage.get(id);
    if (obj) {
      this.centers.detach(obj);
      this.hover.untrack(obj);
    }
    super.removeObject(id);
  }

  override onScroll(): void {
    this.centers.invalidateAll();
  }

  onMouseMove(e: MouseEvent): void {
    const mx = e.clientX,
      my = e.clientY;
    const targets =
      this.nearOnly && this.hover.activeObjects().length
        ? this.hover.activeObjects()
        : this.objects;

    for (let i = 0; i < targets.length; i++) {
      const obj = targets[i];
      const { cx, cy } = this.centers.getCenter(obj);
      const dx = mx - cx,
        dy = my - cy;
      const d2 = dx * dx + dy * dy;

      if (
        this.nearOnly &&
        d2 > this.data.viewport.windowWidth * this.data.viewport.windowWidth &&
        !this.hover.isActive(obj)
      )
        continue;

      this.onPointerDelta(obj, dx, dy, Math.sqrt(d2));
    }
  }

  onFrame(data: StringData): void {
    this.rafFrame++;
    this.onCursorFrame(data, this.rafFrame);
  }

  protected abstract onPointerDelta(obj: StringObject, dx: number, dy: number, dist: number): void;
  protected abstract onCursorFrame(data: StringData, frame: number): void;
}
